var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topicPath"},[_c('ul',[_c('item',{attrs:{"text":"トップ","link":_vm.bizBaseUrl + '/'}}),_c('item',{attrs:{"text":"BIGLOBE光","link":_vm.bizBaseUrl + '/hikari/'}}),_c('item',{attrs:{"text":"料金シミュレーションとお見積り書作成"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }